import React from "react";
import IbanInputWrapper from "./style";
import { InputText } from "primereact/inputtext";
import { useSelector } from "react-redux";

const IbanInput = (props) => {
  const { businessLine } = useSelector((state) => state.travel);

  return (
    <IbanInputWrapper>
      {props.withPrefix && (
        <div className={businessLine ? `prefix-${businessLine}` : "prefix"}>
          SA
        </div>
      )}
      <InputText
        // type="text"
        // mode="decimal"
        id={props.id}
        name={props.name}
        className={props.className}
        placeholder={props.placeholder}
        value={props.value || ""}
        onChange={props.onChange}
        onBlur={props.onBlur}
      />
    </IbanInputWrapper>
  );
};

export default IbanInput;
